/* eslint-disable */
import Vue from 'vue'
import auth from '../api/auth'
import session from '../api/session'
import _ from 'lodash'
import router from '../router'
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_SERVER_CREDENTIALS,
  SET_SLAVE_CREDENTIALS,
  SET_UPDATE_PROFILE_RESPONSE
} from './types'
import { ToastProgrammatic as Toast } from 'buefy'
const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY'

const initialState = {
  authenticating: false,
  recentlyLogged: false, // true when logged in within this session (no vuex restarting, no browse reloading)
  error: false,
  token: null,
  server_credentials: {},
  slave_credentials: {},
  loginResponse: {},
  updateProfileResponse: {},
  sessionid: 'WEBANON',
  profile: {},
  initialized: false,
  photo: null
}
/*"server_credentials": {
           "sessid": "64vLkaZUuP0rq-Bbdx9o6AZQCEoIRxDEUV_LjavWpJI",
           "sessname": "SSESSe840d10bd59c50365fd16994cee05531",
           "X-CSRF-Token": "k5xcbdOfTTYQT8sIsXeyygPzir52kczMH-Aw3I59ILo"
       },
       "slave_credentials": {
           "sessname": "SSESS3e71efd0b9889b97491c2e7cf97ea07c",
           "sessid": "GoMavOSsquE6Y40k9hoxos2TFDdjcDctwXaLyeFiCkA",
           "X-CSRF-Token": "cgM70GqTkrJnuSsPP5cLf9MMUVvmXWS7AQ8xI6crSrw"
       }*/

const getters = {
  isAuthenticated: state => {
    if (_.isEmpty(state.slave_credentials)) return false
    return true
  }
}

const actions = {
  login({ commit }, { email, password }) {
    commit(LOGIN_BEGIN)
    commit('cleanCredentials')
    let authpromise = auth.login(email, password)
    authpromise
      .then(result => {
        commit(SET_SERVER_CREDENTIALS, result.data.data.server_credentials)
        commit(SET_SLAVE_CREDENTIALS, result.data.data.slave_credentials)
        commit('setLoginResponse', result.data)
        return result
      })
      .then(() => commit(LOGIN_SUCCESS))
      .catch(error => {
        if (error.response.status === 403) {
          //first login in this app, terms or conditions not accepted
          let previousLogin = {
            email: email,
            password: password
          }
          // console.log('registerExistingUser')
          router
            .replace({
              name: 'registerExistingUser',
              params: {
                existingUser: true,
                loginData: _.merge(previousLogin, error.response.data)
              }
            })
            .catch(() => {})
        }
        commit(LOGIN_FAILURE)
        return Promise.reject(error)
      })
    return authpromise
  },
  /** Esta función no se usa porque el logout de la api no va bien **/
  logout({ commit }) {
    return auth
      .logout()
      .then(() => {
        commit(LOGOUT)
      })
      .finally(() => {
        commit(REMOVE_TOKEN)
      })
  },
  getPhoto({ commit }) {
    const responsePromise = auth.getUserPhoto()
    return responsePromise
  },
  setProfilePhoto({ commit }, photo) {
    const responsePromise = auth.setUserPhoto(photo);
    return responsePromise
  },
  deletePhoto({ commit }) {
    const responsePromise = auth.deleteUserPhoto()
    return responsePromise
  },
  getProfile({ commit }) {
    const responsePromise = auth.getUserProfile()
    responsePromise.then(result => {
      commit('setProfile', result.data)
      if (_.has(result, 'data.data')) {
        commit('setUpdatedUserinfo', result.data.data)
      }
    })
    return responsePromise
  },
  updateProfile({ commit }, profObj) {
    let responsePromise = auth.updateProfile(
      profObj.professional_number,
      profObj.user_name,
      profObj.user_surname,
      profObj.user_surname2,
      profObj.doctor_jobcenter,
      profObj.doctor_jobcenter_other,
      profObj.administrative_area,
      'ES',
      profObj.doctor_specialty_main,
      profObj.doctor_title,
      profObj.doctor_resident,
      profObj.doctor_resident_year
    )
    responsePromise.then(({ data }) => {
      commit(SET_UPDATE_PROFILE_RESPONSE, data)
    })
    return responsePromise
  },
  resetPassword({ commit }, email) {
    return auth.resetPassword(email)
  },
  initialize({ state, commit }) {
    if (state.initialized === true) return

    const slave_credentials = JSON.parse(
      localStorage.getItem('slave_credentials')
    )
    if (slave_credentials) {
      commit(SET_SLAVE_CREDENTIALS, slave_credentials)
    } else {
      commit(REMOVE_TOKEN)
    }
    const server_credentials = JSON.parse(
      localStorage.getItem('server_credentials')
    )
    if (server_credentials) {
      commit(SET_SERVER_CREDENTIALS, server_credentials)
    } else {
      commit(REMOVE_TOKEN)
    }
    const loginResponse = JSON.parse(localStorage.getItem('loginResponse'))
    if (loginResponse !== null) commit('setLoginResponse', loginResponse)

    commit('setInitialize', true)
  }
}

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true
    state.error = false
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false
    state.error = true
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false
    state.recentlyLogged = true
    state.error = false
  },
  [LOGOUT](state) {
    state.authenticating = false
    state.error = false
  },
  [SET_SERVER_CREDENTIALS](state, server_credentials) {
    localStorage.setItem(
      'server_credentials',
      JSON.stringify(server_credentials)
    )
    //session.defaults.headers.Authorization = `Token ${token}`
    state.server_credentials = server_credentials
  },
  [SET_SLAVE_CREDENTIALS](state, slave_credentials) {
    localStorage.setItem('slave_credentials', JSON.stringify(slave_credentials))
    //https://stackoverflow.com/questions/45578844/how-to-set-header-and-options-in-axios
    session.defaults.headers.common['X-CSRF-TOKEN'] =
      slave_credentials['X-CSRF-Token']
    session.defaults.headers.common['X-NVDUS'] =
      slave_credentials['sessname'] + '=' + slave_credentials['sessid']
    state.slave_credentials = slave_credentials
    state.sessionid = 'WEB' + slave_credentials['X-CSRF-Token'].substring(0, 25)
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem('slave_credentials')
    delete session.defaults.headers.common['X-NVDUS']
    delete session.defaults.headers.common['X-CSRF-TOKEN']
    state.slave_credentials = null
    state.server_credentials = null
    state.loginResponse = null

    localStorage.removeItem('server_credentials')
    localStorage.removeItem('slave_credentials')

    localStorage.removeItem('loginResponse')
    state.sessionid = getAnonymousSessionid()
    state.initialized = false
  },
  [SET_UPDATE_PROFILE_RESPONSE](state, responseData) {
    state.updateProfileResponse = responseData
  },
  wrongSession(state) {
    localStorage.removeItem('slave_credentials')
    localStorage.removeItem('server_credentials')
    localStorage.removeItem('loginResponse')
    delete session.defaults.headers.common['X-NVDUS']
    delete session.defaults.headers.common['X-CSRF-TOKEN']
    state.slave_credentials = null
    state.server_credentials = null
    state.loginResponse = null

    state.authenticating = false
    state.error = false
    state.initialized = false
  },
  setPhoto(state, photoProfile) {
    state.photo = photoProfile
  },
  setProfile(state, profiledata) {
    state.profile = profiledata
  },
  setLoginResponse(state, loginResponse) {
    localStorage.setItem('loginResponse', JSON.stringify(loginResponse))
    state.loginResponse = loginResponse
  },
  /*updateLoginResponse(state,userdata){
    state.loginResponse.user= userdata
    localStorage.setItem("loginResponse",  JSON.stringify(state.loginResponse))
  }, */
  setUpdatedUserinfo(state, newUserinfo) {
    Vue.set(state.loginResponse.data, 'user', newUserinfo)
    localStorage.setItem('loginResponse', JSON.stringify(state.loginResponse))
  },
  cleanCredentials(state, server_credentials) {
    delete session.defaults.headers.common['X-CSRF-TOKEN']
    delete session.defaults.headers.common['X-NVDUS']
    delete session.defaults.headers.common['Cookie']
    state.sessionid = getAnonymousSessionid()
  },
  useProxyCredentials(state) {
    session.defaults.headers.common['X-CSRF-TOKEN'] =
      state.slave_credentials['X-CSRF-Token']
    session.defaults.headers.common['X-NVDUS'] =
      state.slave_credentials['sessname'] +
      '=' +
      state.slave_credentials['sessid']
    state.sessionid =
      'WEB' + state.slave_credentials['X-CSRF-Token'].substring(0, 25)
  },
  useServerCredentials(state) {
    session.defaults.headers.common['X-CSRF-TOKEN'] =
      state.server_credentials['X-CSRF-Token']
    session.defaults.headers.common['X-NVDUS'] =
      state.server_credentials['sessname'] +
      '=' +
      state.server_credentials['sessid']
  },
  setInitialize(state, initialized) {
    state.initialized = initialized
  }
}

//load stored anonymousID or generate a new on
function getAnonymousSessionid() {
  let anonymousID = localStorage.getItem('anonymousID')
  if (anonymousID === null) {
    anonymousID = 'WEBANON' + makeid()
    localStorage.setItem('anonymousID', anonymousID)
  }
  return anonymousID
}

function makeid() {
  var text = ''
  var possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))

  return text
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}
